import { render, staticRenderFns } from "./dependencias.vue?vue&type=template&id=31f1c21a&scoped=true&"
import script from "./dependencias.vue?vue&type=script&lang=ts&"
export * from "./dependencias.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31f1c21a",
  null
  
)

export default component.exports